export default __webpack_public_path__ + "static/media/analytics.492ead4f.png";